import {
  ProjectWorkload,
  RetrieveWorkloadProjectsRequest,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  content: ProjectWorkload[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
};

function getWorkloadProjects(httpClient: HttpClient) {
  return (request: RetrieveWorkloadProjectsRequest) =>
    httpClient.sendHttpRequest<Response>({
      endpoint: `/capacity-planning/workload/${request.resourceId}/projects`,
      method: HttpMethods.POST,
      data: {
        from: request.from,
        to: request.to,
        granularity: request.granularity,
        page: request.page,
        size: request.size,
        ...(request.filter && {
          filter: {
            projects: request.filter.projects?.map(({ uuid }) => uuid),
            projectsElementsTags: request.filter.projectsElementsTags?.map(
              ({ name }) => name,
            ),
            projectsTags: request.filter.projectsTags?.map(({ name }) => name),
            projectPortfolios: request.filter.projectPortfolios?.map(
              ({ uuid }) => uuid,
            ),
            projectStatuses: request.filter.projectStatuses?.map(
              ({ uuid }) => uuid,
            ),
          },
        }),
        ...(request.sort && { sort: request.sort }),
      },
    });
}

export { getWorkloadProjects };
